import { render, staticRenderFns } from "./GiteeWorkspaceModal.vue?vue&type=template&id=06b660b0&"
import script from "./GiteeWorkspaceModal.vue?vue&type=script&lang=js&"
export * from "./GiteeWorkspaceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GiteeWorkspaceModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GiteeWorkspaceModal.vue
// module id = 2365
// module chunks = 1